import { useState, useEffect, useRef } from "react";
export const useIsIntersecting = ({ elementId, triggerOnce, rootMargin, delay, }) => {
    const [isIntersecting, setIsIntersecting] = useState(false);
    const ref = useRef(null);
    useEffect(() => {
        const observer = new IntersectionObserver(([entry]) => {
            if (entry !== undefined) {
                setIsIntersecting(entry.isIntersecting);
                if (entry.isIntersecting && triggerOnce)
                    observer.unobserve(entry.target);
            }
        }, { rootMargin: rootMargin });
        const element = document === null || document === void 0 ? void 0 : document.querySelector(`#${elementId}`);
        const milliSeconds = delay ? delay : 0;
        const timer = setTimeout(() => {
            if (element) {
                observer.observe(element);
                ref.current = element;
            }
        }, milliSeconds);
        return () => {
            observer.disconnect();
            clearTimeout(timer);
        };
    }, [elementId, triggerOnce, rootMargin, delay]);
    return { isIntersecting, ref };
};
